import React from 'react';
import { SpinLoader } from 'deltoid/core/Loaders';

const CustomLoader = ({...rest}) => (
  <SpinLoader {...rest} />
  // <span className="co-full-pg-loader" {...rest}>
  //   <span className="loader-inner"/>
  // </span>
);

export default CustomLoader;